module.exports = __webpack_public_path__ + "static/media/profile.b862ee27.jpg";